import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { capitalizeFirstLetter } from "@perxis-auto/shared/lib/lib/format/capitalizeFirstLetter";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Header } from "@perxis-auto/ui-kit/lib/components/Header";
import styles from "./VehiclesHeader.module.scss.js";
const VehiclesHeader = memo(function VehiclesHeader2({
  isMobile,
  isFilterPanelHidden,
  isFilterPanelVisible,
  totalFavorites,
  onFavoriteClick,
  totalCompared,
  onComparisonClick,
  onFilterPanelToggle,
  t,
  ...props
}) {
  return /* @__PURE__ */ jsx(Header, { className: styles.vehiclesHeader, ...props, children: /* @__PURE__ */ jsxs(Row, { align: "middle", justify: "space-between", wrap: false, children: [
    /* @__PURE__ */ jsx(Col, { flex: "auto", children: !isFilterPanelHidden ? /* @__PURE__ */ jsx(
      Header.ParametersToggler,
      {
        show: isFilterPanelVisible,
        onToggle: onFilterPanelToggle,
        showLabel: isMobile ? capitalizeFirstLetter(t("widgets.vehiclesHeader.optionsFilters")) : t("widgets.vehiclesHeader.showFilters"),
        hideLabel: isMobile ? capitalizeFirstLetter(t("widgets.vehiclesHeader.optionsFilters")) : t("widgets.vehiclesHeader.hideFilters"),
        optionsLabel: isMobile ? void 0 : t("widgets.vehiclesHeader.optionsFilters")
      }
    ) : /* @__PURE__ */ jsx("div", {}) }),
    /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsxs(Row, { align: "middle", gutter: 16, wrap: false, children: [
      /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Header.CounterButton, { count: totalCompared, icon: "compare", onClick: onComparisonClick, children: t("widgets.vehiclesHeader.comparisonLabel") }) }),
      /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Header.CounterButton, { count: totalFavorites, icon: "favorites", onClick: onFavoriteClick, children: t("widgets.vehiclesHeader.favoritesLabel") }) })
    ] }) })
  ] }) });
});
export {
  VehiclesHeader
};
